import {Property} from '../../utilTypes';

export const DOT = new RegExp(/(?<!\\)\./g);

export function getDisplayName(property: Property) {
  if (property.title) {
    return property.title;
  }
  const keyParts = property.key.split(DOT);
  return keyParts[keyParts.length - 1].replaceAll('\\.', '.');
}

export function propertyMapToList(
  props: any,
  parentKey: string | null,
  file: string | null
) {
  const allProperties: Property[] = [];
  for (const key of Object.keys(props)) {
    const p: Property = {
      key: parentKey
        ? parentKey + '.' + key.replaceAll('.', '\\.')
        : key.replaceAll('.', '\\.'),
      file,
      ...props[key],
    };
    allProperties.push(p);
  }
  return allProperties;
}
